import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../theme/theme";

export const useDataGridStyles = makeStyles({
  dataGridContainer: {
    overflowX: "auto",
    boxShadow:
      "inset -20px 0 20px -28px rgba(115, 115, 115, 0.4), inset -30px 0 25px -15px rgba(217, 217, 217, 0.6)",
  },

  dataGrid: {
    "& .fui-DataGridBody": {
      borderBottomLeftRadius: "6px",
      borderBottomRightRadius: "6px",
      border: `1px solid ${customTokens.colorNeutralStroke1}`,
    },

    "& .fui-DataGridHeader": {
      "& .fui-DataGridRow": {
        backgroundColor: customTokens.colorBrandBackground,
        borderTopLeftRadius: "6px",
        borderTopRightRadius: "6px",
        borderBottom: "none",
      },
    },

    "& .fui-DataGridHeaderCell": {
      borderRight: `1px solid ${customTokens.colorNeutralStroke1}`,
      padding: "12px 16px",
      fontWeight: customTokens.fontWeightSemibold,
      color: "white",
      alignSelf: "stretch",
      maxWidth: "100% !important",

      "&:last-child": {
        borderRight: "none",
      },

      "&:hover": {
        backgroundColor: "transparent",
        color: customTokens.colorNeutralGrey94,
      },

      "&:active": {
        backgroundColor: "transparent",
        color: customTokens.colorNeutralGrey94,
      },
    },

    "& .fui-DataGridHeaderCell__button": {
      justifyContent: "space-between",
    },

    "& .fui-DataGridRow": {
      borderBottom: `1px solid ${customTokens.colorNeutralStroke1}`,

      "&:last-child": {
        borderBottom: "none",
      },
    },

    "& .fui-DataGridCell": {
      padding: "12px 16px",
      borderRight: `1px solid ${customTokens.colorNeutralStroke1}`,
      alignSelf: "stretch",
      maxWidth: "100% !important",
      wordBreak: "break-word",

      "&:last-child": {
        borderRight: "none",
      },
    },
  },
});
